import { Chip, type ChipProps, Stack, Tooltip } from "@mui/material";
import type React from "react";

import {
	getStatusThemeColor,
	type Status,
} from "AdvisoryManagement/Shared/Status/statusUtils";

type StatusChipProps = Omit<ChipProps, "color"> & {
	label: React.ReactNode;
	variant?: "filled" | "outlined";
	color?: ChipProps["color"];
	status?: Status;
	title?: string;
};

export const StatusChip = ({
	label,
	variant = "outlined",
	color = "default",
	status,
	title,
	...chipProps
}: StatusChipProps) => {
	const chipColor = status ? getStatusThemeColor(status) : color;

	const chip = (
		<Chip
			label={
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="center"
					spacing={0.5}
				>
					{label}
				</Stack>
			}
			variant={variant}
			color={chipColor}
			{...chipProps}
		/>
	);

	if (title) {
		return (
			<Tooltip title={title} arrow>
				{chip}
			</Tooltip>
		);
	}
	return chip;
};
